import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.project.facility.add');
import { OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-component-project-facility-add',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.project.facility.add/view.scss */
:host {
  display: block;
}`],
})
export class ComponentProjectFacilityAddComponent implements OnInit, OnChanges {
    @Input() isOpen: boolean = false;
    @Input() projectId: string = '';
    @Input() drawings: any[] = [];
    @Output() onClose = new EventEmitter<void>();
    @Output() onCreated = new EventEmitter<void>();

    public data: any = {
        name: '',
        type: '',
        description: '',
        customType: ''
    };
    public facilityTypes: any[] = [
        { code: 'bridge', label: '교량, 육교' },
        { code: 'tunnel', label: '터널, 지하차도' },
        { code: 'retaining_wall', label: '옹벽' },
        { code: 'cut_slope', label: '절토사면' },
        { code: 'building', label: '건축물, 지하도상가' }
    ];
    public drawingsList: any[] = [];
    public isCreating: boolean = false;
    public isUploadingDrawing: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        this.initDrawingsList();
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes['drawings'] || changes['isOpen']) {
            this.initDrawingsList();
        }
    }

    private initDrawingsList() {
        this.drawingsList = (this.drawings || [])
            .filter(d => d?.mpro_managed !== false)
            .map(d => ({ ...d, selected: false }));
    }

    public close() {
        if (this.isCreating || this.isUploadingDrawing) return;
        this.data = { name: '', type: '', description: '', customType: '' };
        this.drawingsList.forEach(d => d.selected = false);
        this.onClose.emit();
    }

    public toggleDrawing(drawing: any) {
        drawing.selected = !drawing.selected;
        this.ref.detectChanges();
    }

    public isPdf(drawing: any): boolean {
        const filepath = drawing?.filepath || drawing?.file_path || '';
        return filepath.toLowerCase().endsWith('.pdf');
    }

    public getFileName(drawing: any): string {
        // DB 스키마: filename 필드 사용
        if (drawing?.filename) return drawing.filename;
        // fallback: filepath에서 추출
        const filepath = drawing?.filepath || drawing?.file_path || '';
        if (!filepath) return '제목 없음';
        const parts = filepath.split('/');
        return parts[parts.length - 1];
    }

    public triggerDrawingUpload() {
        if (this.isUploadingDrawing || this.isCreating) return;
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'application/pdf,image/*';
        input.onchange = (event: any) => {
            const file = event.target.files?.[0];
            if (!file) return;
            if (file.size > 100 * 1024 * 1024) {
                this.service.alert.show({
                    title: '도면 등록 불가',
                    message: '도면 파일은 100MB 이하만 등록할 수 있습니다.',
                    status: 'warning',
                    action: '확인',
                    cancel: false
                });
                return;
            }
            this.uploadDrawing(file);
        };
        input.click();
    }

    private async uploadDrawing(file: File) {
        if (this.isUploadingDrawing || this.isCreating) return;
        this.isUploadingDrawing = true;
        this.ref.detectChanges();
        await this.service.loading.show();

        let alert: any = null;
        try {
            const form = new FormData();
            form.append('project_id', this.projectId);
            form.append('action', 'upload_drawing');
            form.append('file[]', file);
            const response = await fetch(wiz.url('create_facility'), {
                method: 'POST',
                body: form,
                credentials: 'include'
            });
            const payload = await response.json();
            const code = Number(payload?.code ?? response.status);
            const data = payload?.data ?? payload;
            if (code !== 200 && code !== 202) {
                const message = typeof data === 'string'
                    ? data
                    : typeof data?.message === 'string'
                        ? data.message
                        : 'M-Pro 도면 등록에 실패했습니다.';
                throw new Error(message);
            }

            const selectedIds = new Set(
                this.drawingsList.filter(d => d.selected).map(d => d.id)
            );
            const newIds = new Set(
                Array.isArray(data?.new_drawing_ids) ? data.new_drawing_ids : []
            );
            for (const drawingId of newIds) selectedIds.add(drawingId);
            if (Array.isArray(data?.drawings)) {
                const refreshedDrawings = data.drawings;
                const localDrawings = (this.drawings || [])
                    .filter((drawing: any) => drawing?.mpro_managed === false);
                const refreshedIds = new Set(refreshedDrawings.map((drawing: any) => drawing.id));
                const mergedDrawings = [
                    ...refreshedDrawings,
                    ...localDrawings.filter((drawing: any) => !refreshedIds.has(drawing.id))
                ];
                if (Array.isArray(this.drawings)) {
                    this.drawings.splice(0, this.drawings.length, ...mergedDrawings);
                } else {
                    this.drawings = mergedDrawings;
                }
                this.drawingsList = refreshedDrawings
                    .filter((drawing: any) => drawing?.mpro_managed !== false)
                    .map((drawing: any) => ({
                        ...drawing,
                        selected: selectedIds.has(drawing.id)
                    }));
            }
            alert = {
                title: code === 202 ? '도면 등록 완료 · 동기화 대기' : '도면 등록 완료',
                message: typeof data?.message === 'string'
                    ? data.message
                    : code === 202
                        ? '도면은 M-Pro 도면 정보에 등록되었습니다. 잠시 후 다시 확인해 주세요.'
                        : '도면이 M-Pro 도면 정보에 저장되고 자동 선택되었습니다.',
                status: code === 202 ? 'warning' : 'success',
                action: '확인',
                cancel: false
            };
        } catch (error: any) {
            alert = {
                title: '도면 등록 실패',
                message: error?.message || 'M-Pro 도면 등록 요청에 실패했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            };
        } finally {
            await this.service.loading.hide();
            this.isUploadingDrawing = false;
            this.ref.detectChanges();
        }
        if (alert) await this.service.alert.show(alert);
    }

    public async create() {
        if (this.isCreating || this.isUploadingDrawing) return;
        if (!this.data.name.trim()) {
            await this.service.alert.show({
                title: '알림',
                message: '시설물명을 입력하세요.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            return;
        }
        if (!this.data.type) {
            await this.service.alert.show({
                title: '알림',
                message: '시설물 유형을 선택하세요.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            return;
        }
        if (this.data.type === 'custom' && !this.data.customType.trim()) {
            await this.service.alert.show({
                title: '알림',
                message: '시설물 유형을 입력하세요.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            return;
        }

        this.isCreating = true;
        await this.service.loading.show();

        const facilityType = this.data.type === 'custom'
            ? this.data.customType.trim()
            : this.data.type;
        const selectedDrawings = this.drawingsList
            .filter(d => d.selected)
            .map(d => d.id);
        let code = 500;
        let data: any = '';
        try {
            ({ code, data } = await wiz.call('create_facility', {
                project_id: this.projectId,
                name: this.data.name,
                type: facilityType,
                description: this.data.description,
                drawing_ids: JSON.stringify(selectedDrawings)
            }));
        } catch (error: any) {
            data = error?.message || 'M-Pro 시설물 등록 요청에 실패했습니다.';
        } finally {
            await this.service.loading.hide();
            this.isCreating = false;
        }

        if (code === 200 || code === 202) {
            const refreshPending = code === 202;
            const message = typeof data?.message === 'string'
                ? data.message
                : refreshPending
                    ? '시설물은 M-Pro에 등록되었습니다. I-PRO 목록은 잠시 후 새로고침해 주세요.'
                    : '시설물이 M-Pro와 I-PRO에 추가되었습니다.';
            this.onCreated.emit();
            this.close();
            await this.service.alert.show({
                title: refreshPending ? '등록 완료 · 동기화 대기' : '성공',
                message,
                status: refreshPending ? 'warning' : 'success',
                action: '확인',
                cancel: false
            });
        } else {
            const message = typeof data === 'string'
                ? data
                : typeof data?.message === 'string'
                    ? data.message
                    : '시설물 추가에 실패했습니다.';
            await this.service.alert.show({
                title: '오류',
                message,
                status: 'error',
                action: '확인',
                cancel: false
            });
        }

        this.ref.detectChanges();
    }
}

export default ComponentProjectFacilityAddComponent;